import axios from '@/plugins/axios';
import QueryBuilder from '@/utilities/QueryBuilder';

export function getForceStatusFailureMessage(response) {
    const items = response?.data?.data;

    if (!Array.isArray(items)) {
        return null;
    }

    return items.find(item => item?.exception)?.exception ?? null;
}

export async function postProctorDashboardForceStatus(payload) {
    const forceStatus = new QueryBuilder('quiz-attempt-force-status');
    const response = await axios.post(forceStatus.toUrl(), payload, { errorHandle: false });
    const failureMessage = getForceStatusFailureMessage(response);

    if (failureMessage) {
        const error = new Error(failureMessage);
        error.isProctorDashboardForceStatusFailure = true;

        throw error;
    }

    return response;
}
